<template>
  <div class="dicusscontent">
    <div class="dicusslist1">
      <ul>
        <li v-for="item in list" :key="item.id">
          <router-link
            target="_blank"
            :to="{path:`/discussDetail?id=${item.id}&author=${item.userId}&topicId=${item.topicId}`}"
            class="titlestyle"
          >{{item.title}}</router-link>
          <span
            class="userState statewidth"
            :class="{addcolor1:item.status == 1,addcolor2:item.status == 2,addcolor3:item.status == 3}"
          >{{getStatus(item.status)}}</span>
          <a class="backinfor">
            <em>{{item.answerCount}}</em>{{$t('global.回复')}}
          </a>
          <a class="timeinfor">{{timeStamp(item.updateTime)}}</a>
          <router-link
            :to="`/subjectdetail/${item.topicId}/activity`"
            class="writings"
          >{{item.topicName}}</router-link>
        </li>
      </ul>
    </div>

    <pages
      :page-size="pagerParam.pageSize"
      :page-count="pagerParam.pageCount"
      :current-page="pagerParam.currentPage"
      :total="pagerParam.total"
      @current-page-changed="OnCurrentPageChanged"
    ></pages>
  </div>
</template>

<script>
  import pages from "@/components/pages.vue";

  export default {
      name: "storageDicussData",
    components:{pages},
    props:{
       orderBy:{
         type:Number
       },
      isShow:{
         type:Boolean
      }
    },
    data(){
        return {
          list:[],
          pagerParam : {
            pageSize: 20,
            pageCount: 1,
            currentPage: 1,
            total: 1
          }
        }
    },
    created(){
        this.getQuestionList();
    },
    methods:{
      getQuestionList(){

        this.$http.get('/api/u/topicquestion/getMyQuestionDetail',{params:{type:this.orderBy,
            pageIndex:this.pagerParam.currentPage,pageSize:this.pagerParam.pageSize}}).then(response =>{
          this.list = response.data.list;
          this.pagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
        })
      },
      OnCurrentPageChanged(val) {
        this.pagerParam.currentPage = val;
        this.getQuestionList();
      },
      getStatus(val){
        let  str = "";
        switch (val) {
          case 1:
            str = this.$t('global.待审核');
            break;
          case 2:
            str = this.$t('global.审核通过');
            break;
          case 3:
            str = this.$t('global.不通过');
            break;
          case -1:
            str = this.$t('global.已删除');
            break
        }
        return str;
      },
    },
    watch:{
        orderBy(){
          this.getQuestionList();
        },
        isShow(){
          if (this.isShow) {
            this.getQuestionList();
          }
        }
    }
  }
</script>

<style scoped>
em {
  font-style: normal;
}
.dicusscontent .commentnav {
  color: #999;
  font-size: 16px;
  margin: 30px 0;
  overflow: hidden;
}
.dicusscontent .commentnav li {
  float: left;
  cursor: pointer;
  margin-right: 20px;
}
.dicusscontent .commentnav li.active {
  color: #333;
  font-weight: bold;
}
.dicusslist1 h3 {
  font-weight: normal;
  font-size: 20px;
  color: #999;
  margin-bottom: 7px;
}
.dicusslist1 h3 a em {
  font-style: normal;
  margin-left: 3px;
}
.dicusslist1 h3 a {
  color: #4a90e2;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}
.dicusslist1 li {
  height: 18px;
  line-height: 18px;
  padding: 10px 0;
  border-bottom: 1px solid #e2e2e2;
}
.dicusslist1 li > * {
  float: left;
}
.dicusslist1 li .title {
  padding: 1px 7px;
  color: #fff;
  border-radius: 3px;
  background-color: #df7979;
}
.dicusslist1 li .titlestyle {
  font-size: 14px;
  color: #333;
  width: 356px;
  margin: 0 45px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}
.dicusslist1 li .userState {
  font-size: 12px;
  color: #f5a623;
}
.dicusslist1 li .statewidth {
  display: inline-block;
  width: 76px;
  margin-right: 30px;
}
.dicusslist1 li .through {
  color: #34ba9c;
}
.dicusslist1 li .nothrough {
  position: relative;
  color: #d0021b;
}
.dicusslist1 li .backinfor {
  width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dicusslist1 li .timeinfor {
  width: 62px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dicusslist1 li .backinfor,
.dicusslist1 li .timeinfor {
  margin-right: 22px;
  font-size: 12px;
  color: #999;
  height: 16px;
  line-height: 16px;
}
.dicusslist1 li .writings {
  color: #4a90e2;
  font-size: 12px;
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dicusslist1 li .questions {
  padding: 1px 7px;
  color: #fff;
  border-radius: 3px;
  background-color: #4a90e2;
}
.dicusslist2 {
  margin-top: 55px;
}
.dicusslist2 li .titlestyle {
  margin-right: 150px;
}
.dicusslist1 li:last-child {
  border-bottom: none;
}
.dicusslist1 li img {
  position: relative;
  top: -2px;
  left: 5px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.dicusslist1 li .hovershow {
  position: absolute;
  opacity: 0;
  width: 200px;
  height: 40px;
  top: 35px;
  left: 0;
  color: #999;
  padding: 2px 6px;
  font-size: 14px;
  border-radius: 3px;
  overflow: hidden;
  box-shadow: 1px 1px 3px #ccc;
  text-overflow: ellipsis;
  background-color: #f4f4f4;
}
.dicusslist1 li img:hover + .hovershow {
  opacity: 1;
  -webkit-transform: translateY(-7px);
  transform: translateY(-7px);
  -webkit-transition: all 0.2s ease-in;
}

.dicusslist1 li .addcolor1 {
  color: #f5a623;
}
.dicusslist1 li .statewidth {
  display: inline-block;
  width: 76px;
  margin-right: 30px;
}
.dicusslist1 li .addcolor2 {
  color: #34ba9c;
}
.dicusslist1 li .addcolor3 {
  position: relative;
  color: #d0021b;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/storageDicussData.vue